import { graphql } from '@/gql';

// Fragments
import '../../pricing/fragments/currencyPricingDataFragment';
import './partnerFragment';

graphql(`
  fragment CallerFragment on CallerType {
    id
    prefix
    firstName
    lastName
    relation
    isActive
    paymentTier
    phoneNumber
    phoneNumber2
    homeNumber
    email
    dob
    customHomeName
    streetAddress
    streetAddress2
    city
    state
    country
    homeNote
    infoForDriver
    zip
    latitude
    longitude
    homeCoordinatesChanges
    timeZone
    aName
    aPhone
    aLocation
    aLat
    aLong
    aNote
    gourmetANote
    aLocationCoordinatesChanges
    bName
    bPhone
    bLocation
    bLat
    bLong
    bNote
    gourmetBNote
    bLocationCoordinatesChanges
    cName
    cPhone
    cLocation
    cLat
    cLong
    cNote
    gourmetCNote
    cLocationCoordinatesChanges
    hearAboutUs
    createdAt
    billingPlan
    credits
    rideType
    language1
    language2
    langPrefForUI
    langPrefForOperator
    langPrefForDriver
    isNeedHelp
    isNoBigCars
    isVisuallyImpaired
    noAdditionalInfo
    isCane
    isElbowAssist
    isTraveling
    isWalker
    isWheelchair
    isHardOfHearing
    isServiceDog
    isOxygenTank
    isPoorMemory
    isAlwaysOperator
    isSpeech
    isHighAlerts
    flagged
    flagReason
    healthScore
    operatorNote
    deactivationReason
    closedAt
    levelPreferenceForOperator
    managementNote
    partnerSubsidy
    isBusinessAccount
    receiptPhoneNumber
    suspendedAt
    isSuspended
    mailingStreetAddress
    mailingCity
    mailingCountry
    mailingZip
    mailingState
    mailingStreetAddress2
    registeredByUser
    isOnlyRideType
    unpaidRides
    unpaidGroceries
    isOnPartnership
    partner {
      ...PartnerFragment
    }
    partners {
      ...PartnerFragment
    }
    isMustAdjustHomeCoordinates
    referralCode
    operatorNoteUpdatedAt
    note
    isDisableTutorialPlay
    musicGenre
    autoReloadCreditsEnabled
    autoReloadCreditsThresholdAmount
    autoReloadCreditsPaymentAmount
    sentPrintedInvoice
    currency
    units
    isNoSmallCars
    isNoRedMeat
    isNutAllergy
    isDairyAllergy
    isGlutenFree
    isVegan
    isVegetarian
    isLowSugarDiet
    isLowFatsDiet
    isLowFiberDiet
    isLeaveAtDoor
    gourmetNotes {
      dropOffOptionId
      addressNote
      accessibilityNote
    }
    isOutboundCallWithPreviousOrderDisabled
    isRequiredMonitoringGourmetOrder
    driverArriving
    scheduledRideSurgeCall
    scheduledRideCall
    pricePendingRideCall
    callRiderPriceChange
    callRiderDriverCanceled
    cancellationFeeDisputeFailedCall
    sendNeedLoveAutomatedCall
    sendNeedLoveRefundAutomatedCall
    callRiderDriverDetails
    pricePendingRideAfterDateExpiredCall
    callRiderTripCost
    callNewDriverInfo
    callWarnNoShowFee
    scheduledRidePayForAnyUnpaidServicesFailedCall
    scheduledRideUnpaidServicesCallIn24Hours
    scheduledRidePreauthFailedCallIn24Hours
    scheduledRideReminderDayBeforeCall
    scheduledRideCustomReminderCall
    scheduledGroceryPayForAnyUnpaidServicesFailedCall
    scheduledGroceryUnpaidServicesCallIn24Hours
    scheduledGroceryPreauthFailedCallIn24Hours
    scheduledGroceryBeforeTheDayCall
    scheduledGroceryCustomReminderCall
    scheduledDeliveryPayForAnyUnpaidServicesFailedCall
    scheduledDeliveryUnpaidServicesCallIn24Hours
    scheduledDeliveryPreauthFailedCallIn24Hours
    scheduledDeliveryReminderCall
    callPartnerCallerAboutPartnerCredits
    callPartnerCallerAboutPartnerRides
    callWarnInProgressDriverCancellation
    ridesMarketingCalls
    gourmetMarketingCalls
    groceriesMarketingCalls
    noCalls
    marketingCalls
    transactionalSms
    driverAcceptedRideSms
    driverCancelledRideSms
    operatorCancelledRideSms
    redispatchedRideSms
    riderCancelledRideSms
    scheduledRideConfirmationSms
    scheduledRideCancelledSms
    scheduledRideSurgeSmsForCaller
    nextRideSmsOrdering
    gogoNumber
    scheduledGroceryConfirmationSms
    deliveryArrivalSms
    marketingSms
    groceryOrderOutsideReminderSms
    transactionalEmails
    noMail
    marketingMail
    addPaymentSourceEmail
    updatePaymentSourceEmail
    defaultPaymentSourceEmail
    deletePaymentSourceEmail
    apologyRefundEmail
    blockDriverEmail
    cancellationFeeDisputeFailedEmail
    cancellationFeeDisputeSuccessEmail
    closingAccountEmail
    falseTripDisputeFailedEmail
    falseTripDisputeSuccessEmail
    fareDisputeFailedEmail
    fareDisputeSuccessEmail
    findLostItemFailedEmail
    refundEmail
    giftCardNotificationEmail
    giftCardReceiptEmail
    membershipRenewalReminderEmail
    membershipConfirmationEmail
    membershipFailedEmail
    membershipReceiptEmail
    membershipTrialConfirmationEmail
    membershipTrialWillEndEmail
    gogoGourmetReceiptEmail
    needLoveRefundEmail
    newRideCreditsNotificationEmail
    noPaymentMethodOnFileEmail
    noRidesCallerEmail
    noShowReceiptEmail
    partnerCreditsNotificationEmail
    partnerRidesNotificationEmail
    refundRideEmail
    rideCancellationReceiptEmail
    rideCreditsRenewalEmail
    rideHistoryEmail
    rideReceiptEmail
    scheduledRideCancelledEmail
    scheduledRideChangedEmail
    scheduledRideConfirmedEmail
    scheduledRideReminderDayBeforeEmail
    scheduledRideUnpaidServicesEmail
    scheduledRidePreauthFailedEmail
    scheduledGroceryCanceledEmail
    scheduledGroceryChangedEmail
    scheduledGroceryConfirmedEmail
    scheduledGroceryReminderEmail
    scheduledGroceryUnpaidServicesEmail
    scheduledGroceryPreauthFailedEmail
    scheduledDeliveryReminderEmail
    scheduledDeliveryUnpaidServicesEmail
    scheduledDeliveryPreauthFailedEmail
    surgePricingWasConfirmedEmail
    welcomeEmail
    welcomeEmailForUsersWithPartners
    gourmetRestaurantsMail
    monthlyInvoiceMail
    reactivationPostcardsMail
    happyBirthdayPostcardsMail
    homeDriverArrivingEta
    deactivationPassedAwayEmail
    suspendingAccountMembershipEmail
    groceryReceiptEmail
    groceryReceivedEmail
    groceryOrderReminderEmail
    isMembershipExpired
    isNeverHadMembership
    isTakenPaidMonthlyPlan
    isInFirstMonthOfHardRegister
    subscriptionStartAt
    isGrandfatheredUser
    isOldCanadianUser
    subscriptionChargeSuccessCall
    subscriptionChargeFailedCall
    membershipRenewalReminderCall
    membershipTrialWillEndIn3DaysCall
    weeklyCheckInMarketingCall
    groceryOrderShoppingCall
    groceryOrderShoppingCompleteCall
    groceryOrderInTransitCall
    groceryOrderCanceledCall
    groceryOrderReminderCall
    groceryOrderOutsideReminderCall
    etaDelayCall
    groceryNote
    groceryShopperNote
    isMembershipSuspended
    isPowerWheelchairScooter
    medicalNote
    unpaidGourmetOrders
    isVerballyImpaired
    isAda
    isSlowWalker
    isGroceryHighAlerts
    pharmacyNote
    partnerCredits
    creditsOriginal
    partnerRides
    externalPartnerCallerId
    preAuthorizationNumber
    partnerSuspensionDate
    partnerBeginningDate
    partnerMonthlyBudgetAmount
    partnerEmergencyContact
    partnerProgramManager
    defaultRideAllowanceTier
    defaultRideAllowanceAmount
    isAutoTip
    tipType
    tipAmount
    tipMinAmount
    tipMaxAmount
    isAllowVoipPhoneNumbers
    isTurnOffAutoSavingAddress
    refundDepositDeniedEmail
    refundDepositDeniedCall
    marketingEmails
    priceConfirm
    deliveryArrivalCall
    deliveryAfterOrderCall
    deliveryAfterHoursOrderStatusUpdateCall
    isSendUserPhoneNumberInDriverAcceptedTextMessage
    visitorId
    stripeCustomerId
    stripeAccountName
    partnerNote
    activeRides {
      id
      serviceType
    }
    activeGroceries
    activeDeliveries

    callerPhoneNumbers {
      phoneNumber
      phoneInfo
    }
    isAskedUserForEmail
    associatedAbTests
    registerPlan
    lastPlanName
    isNeedToOfferScheduleOrder
    accountReactivateEmail
    driverCanceledEmail
    freeTrialReminderEmail
    groceryOrderUpdateEmail
    homeServicesReceiptEmail
    isAffiliateCaller
    numerOfReferredUsers
    activeScheduledRide {
      id
    }
    activeScheduledGrocery {
      id
    }
    activeScheduledGourmet {
      id
    }
    trialInfo {
      periodCode
      isEligible
      isCurrent
      days
    }
    planPricing {
      accent
      annual {
        activeHours
        authorizedGuestTrips
        dashboard
        emergencyCalls
        favoriteOperators
        freeGroceries
        freeRides
        goGoCare
        rideLimit
        gourmetPaymentTier {
          ...CurrencyPricingDataFragment
        }
        groceryPaymentTier {
          ...CurrencyPricingDataFragment
        }
        groceryStandingOrder
        homeServiceOneTimePaymentTier {
          ...CurrencyPricingDataFragment
        }
        homeServiceRecurringPaymentTier {
          ...CurrencyPricingDataFragment
        }
        homeServices
        insuranceAndTaxStatements
        isAlwaysOperator
        isFreePrintedInvoice
        isHighAlerts
        leisureTrips
        lovedOnesLimit
        operatorOrderedRidePrice {
          ...CurrencyPricingDataFragment
        }
        pharmacyPaymentTier {
          ...CurrencyPricingDataFragment
        }
        planKind
        price {
          AUD
          CAD
          USD
        }
        prioritySupport
        proactiveCareManagement
        ridePaymentTier {
          ...CurrencyPricingDataFragment
        }
        specialRequestPaymentTier {
          ...CurrencyPricingDataFragment
        }
        splitPayments
        turningOffReceipts
        wellnessChecks
      }
      annualPerMonthPrice {
        AUD
        CAD
        USD
      }
      annualSavingsAmount {
        AUD
        CAD
        USD
      }
      annualSavingsPercent
      monthly {
        activeHours
        authorizedGuestTrips
        dashboard
        emergencyCalls
        favoriteOperators
        freeGroceries
        freeRides
        goGoCare
        rideLimit
        gourmetPaymentTier {
          ...CurrencyPricingDataFragment
        }
        groceryPaymentTier {
          ...CurrencyPricingDataFragment
        }
        groceryStandingOrder
        homeServiceOneTimePaymentTier {
          ...CurrencyPricingDataFragment
        }
        homeServiceRecurringPaymentTier {
          ...CurrencyPricingDataFragment
        }
        homeServices
        insuranceAndTaxStatements
        isAlwaysOperator
        isFreePrintedInvoice
        isHighAlerts
        leisureTrips
        lovedOnesLimit
        operatorOrderedRidePrice {
          ...CurrencyPricingDataFragment
        }
        pharmacyPaymentTier {
          ...CurrencyPricingDataFragment
        }
        planKind
        price {
          AUD
          CAD
          USD
        }
        prioritySupport
        proactiveCareManagement
        ridePaymentTier {
          ...CurrencyPricingDataFragment
        }
        specialRequestPaymentTier {
          ...CurrencyPricingDataFragment
        }
        splitPayments
        turningOffReceipts
        wellnessChecks
      }
    }
    hasDroppedEmail
    dialogflow
    isAutoRetryGettingEstimate
    homeServiceNote
    isBudgetPlanOfferUser
    crmActivationCampaignEmail
    crmActivationHardRegistrationCampaignEmail
    crmMomentumEngagementCampaignEmail
    crmCrossSellGourmetCampaignEmail
    crmCrossSellGroceriesCampaignEmail
    crmCrossSellHomeServicesCampaignEmail
    crmReactivationCampaignEmail
    crmResurrectionCampaignEmail
    crmActivationDormantSoftRegistrationCampaignEmail
    crmActivationNewUserGroceryRegistrationEmail
    crmActivationDormantHardRegistrationCampaignEmail
    crmActivationNewUserAddedCCRegistrationEmail
    crmActivationNewUserGourmetRegistrationEmail
    crmActivationNewUserOnlineRegistrationEmail
    crmActivationNewUserPhoneRegistrationEmail
    crmActivationNewUserPickedPlanRegistrationEmail
    crmRevivalCampaignEmail
    crmActivationCampaignSms
    crmActivationHardRegistrationCampaignSms
    crmMomentumEngagementCampaignSms
    crmCrossSellGourmetCampaignSms
    crmCrossSellGroceriesCampaignSms
    crmCrossSellHomeServicesCampaignSms
    crmReactivationCampaignSms
    crmResurrectionCampaignSms
    crmActivationDormantSoftRegistrationCampaignSms
    crmActivationNewUserGroceryRegistrationSms
    crmActivationDormantHardRegistrationCampaignSms
    crmActivationNewUserAddedCCRegistrationSms
    crmActivationNewUserGourmetRegistrationSms
    crmActivationNewUserOnlineRegistrationSms
    crmActivationNewUserPhoneRegistrationSms
    crmActivationNewUserPickedPlanRegistrationSms
    crmRevivalCampaignSms
    noCrm
    abTestOptions
    isExpandDriverSearch
    isExpandVehicleSearch
    personalCode
    hasReturnedWelcomeKit
    optedOutPhoneNumbers
    isSoftRegSenior
    isFromLovedOnePhoneNumber
    randomNumber
    promo {
      code
      name
      description
    }
    managementNoteUpdatedAt
    canConvertToDirectExpress
    ebtCard {
      cardNumber
      pinNumber
    }
    isBirthday
    activeExpiringCredits {
      id
      service
      promoCode
      subsidyCount
      promo {
        code
        amount
        name
        description
        isActive
        expiresAt
        type
        expiringCreditData
      }
    }
    isVoicemailRetentionSmsSent
    firstService
  }
`);
